import React from 'react'
import { Vertical, BBDTag, addCommasToNumber } from '@gravitate-js/excalibrr'
import { ArrowDownOutlined, ArrowUpOutlined, CheckOutlined } from '@ant-design/icons'
import classNames from 'classnames'

export const DirectiveDeltaTag = ({ delta, className = 'ml-3' }) => {
  const onTarget = delta === 0 || !delta
  const isOver = delta > 0
  const isUnder = delta < 0
  const StatusIcon = () => {
    if (onTarget) {
      return <CheckOutlined className='pr-2' />
    } else if (isOver) {
      return <ArrowUpOutlined className='pr-2' />
    } else if (isUnder) {
      return <ArrowDownOutlined className='pr-2' />
    }
    return null
  }
  return (
    <Vertical className={className} style={{ maxWidth: 130 }}>
      <BBDTag
        style={{ fontWeight: 'bold' }}
        success={onTarget}
        className={classNames('directive-status-tag', { over: isOver }, { under: isUnder })}
      >
        <StatusIcon />
        {onTarget ? 'On Target' : `${addCommasToNumber(Math.abs(delta), 0)} ${isOver ? 'Over' : 'Under'}`}
      </BBDTag>
    </Vertical>
  )
}
